export const COLORS = {
    primary: "#da0d07",
    secondary: "#272730"
}